import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AdminLoginComponent } from "./pages/admin-login/admin-login.component";
import { ErrorPageComponent } from "./pages/error-page/error-page.component";
import { ThankyouComponent } from "./pages/thankyou/thankyou.component";
import { UserVerificationComponent } from "./pages/user-verification/user-verification.component";
import { AuthGuard } from "./services/auth.guard";
import { AlreadySubmittedComponent } from "./pages/already-submitted/already-submitted.component";
import { CustomerLayoutComponent } from "./layouts/customer-layout/customer-layout.component";


const routes: Routes = [
  // {
  //   path: "",
  //   redirectTo: "presentation",
  //   pathMatch: "full"
  // },
  {
    path: "",
    redirectTo: "admin-login",
    pathMatch: "full"
  },
  {
    path: 'admin-login',
    component: AdminLoginComponent
  },
  {
    path: '404',
    component: ErrorPageComponent
  },
  {
    path: 'already-submitted',
    component: AlreadySubmittedComponent
  },
  {
    path: 'thank-you',
    component: ThankyouComponent
  },
  {
    path: 'user-verification/:id',
    component: UserVerificationComponent
  },

  
  {
    path: "admin",
    component: AdminLayoutComponent,
    children: [
          {
            path: "",
            loadChildren:
              "./layouts/admin-layout/admin-layout.module#AdminLayoutModule",
            canLoad: [AuthGuard],
          }
        ]
  },
  {
    path: "",
    component: CustomerLayoutComponent,
    children: [
          {
            path: "",
            loadChildren:
              "./layouts/customer-layout/customer-layout.module#CustomerLayoutModule",
          }
        ]
  },
  // {
  //   path: "",
  //   component: AuthLayoutComponent,
  //   children: [
  //     {
  //       path: "examples",
  //       loadChildren:
  //         "./layouts/auth-layout/auth-layout.module#AuthLayoutModule"
  //     }
  //   ]
  // },
  {
    path: "**",
    redirectTo: "404"
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
